module.exports = __webpack_public_path__ + "img/status_6.5ab4873b.png";